function joinClassNames(...values) {
  return values.filter(Boolean).join(' ');
}

export function resolveRootOnlyCompactClassNames({
  isCompact,
  rootClassName,
  compactRootClassName,
  innerClassName,
}) {
  return {
    rootClassName: joinClassNames(rootClassName, isCompact ? compactRootClassName : ''),
    innerClassName,
  };
}
